/*
 * Geo / language suggestion popup (remplace Orbe).
 *
 * Affiche une modale (liste Pays + liste Langue + Valider) si :
 *   - le marché courant diffère du marché du pays GÉOLOCALISÉ, et/ou
 *   - la langue courante diffère de la langue du NAVIGATEUR.
 *
 * - Langue détectée via navigator.languages (client, zéro réseau).
 * - Pays détecté via /browsing_context_suggestions.json (natif Shopify, géo-IP serveur,
 *   même origine), mis en cache cookie.
 * - La liste Pays est présélectionnée sur le pays géolocalisé, la liste Langue sur la langue
 *   du navigateur. "Valider" poste le formulaire natif localization (country_code + locale_code + return_to).
 * - Affiché une seule fois (localStorage). Désactivé dans l'éditeur de thème.
 *
 * Debug : ?geo_test=US force l'évaluation avec ce pays et ignore le cache/dismiss.
 */
(function () {
  'use strict';

  var DISMISS_KEY = 'pdd-geo-suggest-dismissed';
  var COUNTRY_COOKIE = 'pdd-geo-country';

  var testCountry = null;
  try {
    testCountry = new URLSearchParams(window.location.search).get('geo_test');
  } catch (e) {}

  if (window.Shopify && window.Shopify.designMode) return;
  if (!testCountry) {
    try {
      if (window.localStorage.getItem(DISMISS_KEY)) return;
    } catch (e) {
      return; // localStorage indisponible -> on s'abstient
    }
  }

  var dataEl = document.getElementById('GeoSuggestData');
  var root = document.getElementById('GeoSuggest');
  var form = document.getElementById('GeoSuggestForm');
  if (!dataEl || !root || !form) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  // Libellés de la modale, affichés dans la langue suggérée (fallback : courante, puis en).
  var I18N = {
    fr: { title: 'Choisissez votre pays et votre langue', country: 'Pays', language: 'Langue', submit: 'Continuer' },
    en: { title: 'Choose your country and language', country: 'Country', language: 'Language', submit: 'Continue' }
  };
  function dict(lang) {
    return I18N[lang] || I18N[data.currentLang] || I18N.en;
  }

  var countrySelect = form.querySelector('select[name="country_code"]');
  var langSelect = form.querySelector('select[name="locale_code"]');
  var returnInput = form.querySelector('input[name="return_to"]');

  function readCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    document.cookie =
      name + '=' + encodeURIComponent(value) + (days ? '; max-age=' + days * 86400 : '') + '; path=/; SameSite=Lax';
  }

  // Langue PRINCIPALE du navigateur uniquement (navigator.languages[0] / navigator.language).
  // On ne parcourt pas toute la liste : sinon une langue secondaire (ex. le français listé après
  // l'espagnol chez un visiteur en France) serait choisie au lieu du repli anglais attendu.
  // Si la langue principale n'est pas proposée par la boutique -> anglais (si dispo), sinon null.
  function preferredLanguage() {
    var navLangs = navigator.languages || [navigator.language || ''];
    var primary = String(navLangs[0] || '').toLowerCase().split('-')[0];
    if (data.languages.indexOf(primary) !== -1) return primary;
    return data.languages.indexOf('en') !== -1 ? 'en' : null;
  }

  function findCountry(iso) {
    if (!iso) return null;
    for (var i = 0; i < data.countries.length; i++) {
      if (data.countries[i].iso === iso) return data.countries[i];
    }
    return null;
  }

  function setSelect(select, value) {
    if (!value) return;
    var v = String(value).toLowerCase();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value.toLowerCase() === v) {
        select.selectedIndex = i;
        return;
      }
    }
  }

  function dismiss() {
    try { window.localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
    root.setAttribute('hidden', '');
    document.removeEventListener('keydown', onKeydown);
  }
  function onKeydown(e) {
    if (e.key === 'Escape') dismiss();
  }

  function onSubmit() {
    // return_to = l'URL alternée hreflang de la langue CHOISIE (au moment du clic).
    var sel = langSelect.value;
    var rt = window.location.pathname + window.location.search;
    var alt = document.querySelector('link[rel="alternate"][hreflang="' + sel + '"]');
    if (alt) {
      try { rt = new URL(alt.href).pathname + window.location.search; } catch (e) {}
    }
    returnInput.value = rt;
    try { window.localStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
  }

  function showPopup(detectedCountryIso, preferredLang) {
    var lang = preferredLang || data.currentLang;
    var d = dict(lang);
    root.querySelector('.geo-suggest__title').textContent = d.title;
    form.querySelector('[data-geo-label="country"]').textContent = d.country;
    form.querySelector('[data-geo-label="language"]').textContent = d.language;
    form.querySelector('[data-geo-label="submit"]').textContent = d.submit;
    root.lang = lang;

    // Présélections : pays géolocalisé + langue du navigateur.
    setSelect(countrySelect, detectedCountryIso);
    setSelect(langSelect, preferredLang);

    Array.prototype.forEach.call(root.querySelectorAll('[data-geo-dismiss]'), function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        dismiss();
      });
    });
    form.addEventListener('submit', onSubmit);

    root.removeAttribute('hidden');
    document.addEventListener('keydown', onKeydown);
  }

  function evaluate(detectedCountryIso) {
    var prefLang = preferredLanguage();
    var langMismatch = !!prefLang && prefLang !== data.currentLang;

    var country = findCountry(detectedCountryIso);
    var countryMismatch = !!country && country.iso !== data.currentCountry;

    // Mode debug (?geo_test=XX) : on force l'affichage pour pouvoir prévisualiser l'UI.
    if (!testCountry && !langMismatch && !countryMismatch) return; // déjà au bon endroit

    showPopup(country ? country.iso : null, prefLang);
  }

  function run() {
    if (testCountry) {
      evaluate(testCountry.toUpperCase());
      return;
    }
    var cached = readCookie(COUNTRY_COOKIE);
    if (cached) {
      evaluate(cached);
      return;
    }
    fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var iso = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (iso) writeCookie(COUNTRY_COOKIE, iso, 7);
        evaluate(iso || null);
      })
      .catch(function () { evaluate(null); });
  }

  var idle = window.requestIdleCallback || function (cb) { return window.setTimeout(cb, 1); };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { idle(run); });
  } else {
    idle(run);
  }
})();
